import * as React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';

const Button = styled.button<{ $size: number }>`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	border: none;
	background: transparent;
	padding: 4px;
	margin: 0;
	color: var(--secondary-color);
	cursor: pointer;

	&:hover {
		color: var(--hover-grey);
	}

	svg {
		width: ${({ $size }) => $size}px;
		height: ${({ $size }) => $size}px;
	}
`;

interface ClearButtonProps {
	onClick: () => void;
	size?: number;
}

export const ClearButton: React.FC<ClearButtonProps> = ({ onClick, size = 14 }) => {
	const { t } = useTranslation();

	return (
		<Button type="button" onClick={onClick} aria-label={t('Tühjenda otsing')} $size={size}>
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
				<line x1="4" y1="4" x2="20" y2="20" strokeLinecap="round" />
				<line x1="20" y1="4" x2="4" y2="20" strokeLinecap="round" />
			</svg>
		</Button>
	);
};
